import gradingSlice from './slice';
import * as Thunks from './thunks';

export const actions = { ...gradingSlice.actions, ...Thunks };
export default gradingSlice.reducer;
